import { Controller } from "@hotwired/stimulus"

// Prevents browser default file drop behavior on container areas
// This stops the browser from navigating to a dropped file when
// the user misses a valid drop target
//
// Usage:
//   On a container element:
//     data-controller="tax-organizer--drop-zone-container"
//
export default class extends Controller {
  connect() {
    this.boundPreventDefault = this.preventDefault.bind(this)

    this.element.addEventListener("dragover", this.boundPreventDefault)
    this.element.addEventListener("drop", this.boundPreventDefault)
  }

  disconnect() {
    this.element.removeEventListener("dragover", this.boundPreventDefault)
    this.element.removeEventListener("drop", this.boundPreventDefault)
  }

  preventDefault(event) {
    event.preventDefault()
  }
}
